(function () {
  'use strict';

  var STORAGE_KEY = 'mm-holder-finder-product-attribution-v1';
  var MAX_ATTRIBUTION_AGE_MS = 7 * 24 * 60 * 60 * 1000;

  function initHolderFinderAttribution() {
    var attribution = readAttribution();
    var currentHandle = getProductHandle(window.location.pathname);

    if (!attribution || !currentHandle || attribution.product_handle !== currentHandle) {
      return;
    }

    document.querySelectorAll('[data-product-form]').forEach(function (productForm) {
      if (getFormProductHandle(productForm) !== currentHandle) {
        return;
      }

      var form = productForm.querySelector('form[action*="/cart/add"]');
      if (!form) {
        return;
      }

      setPrivateProperty(form, '_Holder Finder', 'Yes');
      setPrivateProperty(form, '_Finder device', attribution.device);
      setPrivateProperty(form, '_Finder fit', [attribution.case_label, attribution.measurement_label].filter(Boolean).join(' | '));
      setPrivateProperty(form, '_Finder dimensions', attribution.dimensions);
      setPrivateProperty(form, '_Finder result', attribution.result_type);
      setPrivateProperty(form, '_Finder recommended SKU', attribution.recommended_sku);
    });
  }

  function readAttribution() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var attribution = raw ? JSON.parse(raw) : null;
      var savedAt = attribution ? Number(attribution.saved_at) : 0;
      var isExpired = !savedAt || Date.now() - savedAt > MAX_ATTRIBUTION_AGE_MS;

      if (isExpired) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return attribution;
    } catch (error) {
      return null;
    }
  }

  function getProductHandle(pathname) {
    var match = String(pathname || '').match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getFormProductHandle(productForm) {
    try {
      var product = JSON.parse(productForm.getAttribute('data-product') || '{}');
      return product.handle || '';
    } catch (error) {
      return '';
    }
  }

  function setPrivateProperty(form, label, value) {
    var cleanValue = String(value || '').trim().slice(0, 200);
    if (!cleanValue) {
      return;
    }

    var inputName = 'properties[' + label + ']';
    var existing = Array.prototype.find.call(form.elements, function (field) {
      return field.name === inputName;
    });
    var input = existing || document.createElement('input');

    input.type = 'hidden';
    input.name = inputName;
    input.value = cleanValue;
    input.setAttribute('data-mm-holder-finder-attribution', '');

    if (!existing) {
      form.appendChild(input);
    }
  }

  if (window.__mmHolderFinderAttributionLoaded) {
    if (typeof window.mmInitHolderFinderAttribution === 'function') {
      window.mmInitHolderFinderAttribution();
    }
    return;
  }

  window.__mmHolderFinderAttributionLoaded = true;
  window.mmInitHolderFinderAttribution = initHolderFinderAttribution;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHolderFinderAttribution);
  } else {
    initHolderFinderAttribution();
  }

  window.addEventListener('pageshow', initHolderFinderAttribution);
  document.addEventListener('shopify:section:load', initHolderFinderAttribution);

  if (window.InstantClick && typeof window.InstantClick.on === 'function') {
    window.InstantClick.on('change', initHolderFinderAttribution);
  }
})();
